import { ProductDate } from '../../lib/types/models/product/product-date'
import { ProductDateInput } from '../../lib/types/models/product/product-date-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const duplicateProductDate = (data: IdInput<ProductDateInput>) => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.products.duplicateProductDate.url, { id }))
    .post<ProductDate, ProductDateInput>(rest)
}
